/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Section_AccountInputs */

const en_settings_section_account = /** @type {(inputs: Settings_Section_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Account`)
};

const es_settings_section_account = /** @type {(inputs: Settings_Section_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cuenta`)
};

const fr_settings_section_account = /** @type {(inputs: Settings_Section_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compte`)
};

const de_settings_section_account = /** @type {(inputs: Settings_Section_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konto`)
};

const ja_settings_section_account = /** @type {(inputs: Settings_Section_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アカウント`)
};

const zh_settings_section_account = /** @type {(inputs: Settings_Section_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`账号`)
};

const ar_settings_section_account = /** @type {(inputs: Settings_Section_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الحساب`)
};

const id_settings_section_account = /** @type {(inputs: Settings_Section_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Akun`)
};

const it_settings_section_account = /** @type {(inputs: Settings_Section_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Account`)
};

const ru_settings_section_account = /** @type {(inputs: Settings_Section_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Аккаунт`)
};

const pt_settings_section_account = /** @type {(inputs: Settings_Section_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conta`)
};

const ko_settings_section_account = /** @type {(inputs: Settings_Section_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`계정`)
};

/**
* | output |
* | --- |
* | "Account" |
*
* @param {Settings_Section_AccountInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const settings_section_account = /** @type {((inputs?: Settings_Section_AccountInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Section_AccountInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_section_account(inputs)
	if (locale === "es") return es_settings_section_account(inputs)
	if (locale === "fr") return fr_settings_section_account(inputs)
	if (locale === "de") return de_settings_section_account(inputs)
	if (locale === "ja") return ja_settings_section_account(inputs)
	if (locale === "zh") return zh_settings_section_account(inputs)
	if (locale === "ar") return ar_settings_section_account(inputs)
	if (locale === "id") return id_settings_section_account(inputs)
	if (locale === "it") return it_settings_section_account(inputs)
	if (locale === "ru") return ru_settings_section_account(inputs)
	if (locale === "pt") return pt_settings_section_account(inputs)
	return ko_settings_section_account(inputs)
});